// Content + asset map for the standalone cinematic DION experience page.
// German only, medically responsible copy. Imagery is symbolic (not real patients)
// unless it is genuine Dion Hair Clinic media (clinic rooms, Long Hair FUE footage).

export const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_dion-hair/artifacts/cm40t14d_DionHairClinic_Logo.svg';

export const IMG = {
  hero: '/images/dion/hero-portrait.jpg',
  portrait: '/images/dion/portrait-threequarter.jpg',
  follicle: '/images/dion/follicle-macro.jpg',
  instrument: '/images/dion/instrument-metal.jpg',
  beard: '/images/dion/beard-profile.jpg',
  brows: '/images/dion/brows-macro.jpg',
  donor: '/images/dion/donor-backhead.jpg',
  final: '/images/dion/final-portrait.jpg',
  opRaum: '/images/optimized/DionHairClinic_OP_Raum.webp',
  flur: '/images/optimized/DionHairClinic_Flur.webp',
  eingang: '/images/optimized/DionHairClinic_Eingang.webp',
  warte: '/images/optimized/DionHairClinic_Wartebereich.webp',
};

const CA = 'https://customer-assets.emergentagent.com';
export const VIDEO = {
  longHair: `${CA}/job_follicle-wizard/artifacts/i3r32fur_ergueney.mp4`,
  longHairAlt: `${CA}/job_follicle-wizard/artifacts/mvg2maej_bulut.mp4`,
};

export const BEFORE_AFTER = {
  before: `${CA}/job_hair-expertise/artifacts/tf18b2ql_Haartransplantation_vorher_1.webp`,
  after: `${CA}/job_hair-expertise/artifacts/nepxlcut_Haartransplantation_nachher_1.webp`,
};

export const NAV_LINKS = [
  { id: 'behandlungen', label: 'Behandlungen' },
  { id: 'methoden', label: 'Methoden' },
  { id: 'long-hair-fue', label: 'Long Hair FUE' },
  { id: 'expertise', label: 'Expertise' },
  { id: 'ergebnisse', label: 'Ergebnisse' },
  { id: 'ueber-uns', label: 'Über uns' },
];

export const TREATMENTS = [
  {
    id: 'haartransplantation',
    label: 'Haartransplantation',
    image: IMG.hero,
    focus: 'Haarlinie & Deckhaar',
    text: 'Individuell geplante Haarlinien im natürlichen Wuchswinkel. Abgestimmt auf Gesichtsproportionen, Haarstruktur und Spenderbereich.',
  },
  {
    id: 'augenbrauen',
    label: 'Augenbrauentransplantation',
    image: IMG.brows,
    focus: 'Form & Ausdruck',
    text: 'Natürlich geformte Augenbrauen mit Eigenhaar. Feine Platzierung für einen ruhigen, harmonischen Ausdruck.',
  },
  {
    id: 'bart',
    label: 'Barttransplantation',
    image: IMG.beard,
    focus: 'Kontur & Dichte',
    text: 'Mehr Kontur und Charakter. Lücken auffüllen oder den Bart verdichten – mit dem eigenen Haar.',
  },
  {
    id: 'prp',
    label: 'PRP-Therapie',
    image: IMG.follicle,
    focus: 'Begleitende Behandlung',
    text: 'Eine begleitende Maßnahme, deren Eignung individuell in der persönlichen Beratung besprochen wird.',
  },
];

export const METHODS = [
  {
    id: 'saphir',
    name: 'Saphir FUE',
    line: 'Feine Kanäle. Gezielte Platzierung.',
    text: 'Einzelne Follikeleinheiten werden entnommen. Feine Saphirklingen bereiten die Kanäle präzise vor – ausgerichtet an der geplanten Haarlinie und der natürlichen Wuchsrichtung.',
    image: IMG.instrument,
  },
  {
    id: 'dhi',
    name: 'DHI FUE',
    line: 'Ein Instrument. Viel Feingefühl.',
    text: 'Bei der Direct Hair Implantation werden Follikeleinheiten mit einem Implanter-Pen eingesetzt. Position, Tiefe und Winkel lassen sich gezielt steuern.',
    image: IMG.instrument,
  },
  {
    id: 'longhair',
    name: 'Long Hair FUE',
    line: 'Lange Haarschäfte. Ohne vollständige Rasur.',
    text: 'Follikeleinheiten werden mit erhaltenem Langhaar verpflanzt. Bei geeigneter Ausgangslage ist eine Behandlung ohne vollständige Rasur möglich – mit besonderem Blick auf Diskretion.',
    image: IMG.follicle,
  },
  {
    id: 'hybrid',
    name: 'Hybrid-Ansatz',
    line: 'Kombiniert. Individuell geplant.',
    text: 'Techniken werden nicht als Produkt gewählt, sondern nach Ausgangssituation kombiniert. Welche Methode geeignet ist, klären wir gemeinsam in der Beratung.',
    image: IMG.instrument,
  },
];

export const TEAM = [
  { name: 'Blerina Bevapi', image: '/images/optimized/Blerina-Bevapi.webp' },
  { name: 'Dilek Ergüney', image: '/images/optimized/Dilek-Ergueney.webp' },
  { name: 'Songül Bulut', image: '/images/optimized/Songuel-Bulut.webp' },
];

export const RESULT_STAGES = [
  { id: 'vor', label: 'Vor der OP' },
  { id: 'tag2', label: 'Tag 2' },
  { id: 'w2', label: '2 Wochen' },
  { id: 'w6', label: '6 Wochen' },
  { id: 'm6', label: '6 Monate' },
  { id: 'm12', label: '12 Monate' },
];

export const RESULT_VIEWS = [
  { id: 'front', label: 'Front' },
  { id: 'top', label: 'Top' },
  { id: 'donor', label: 'Spenderbereich' },
];

export const PROCESS = [
  { n: '01', title: 'Beratung', text: 'Ein persönliches Gespräch über Ihre Ausgangssituation, Ihre Wünsche und realistische Möglichkeiten.', image: IMG.warte },
  { n: '02', title: 'Planung', text: 'Haarlinie, Wuchsrichtung und Verteilung werden im Zusammenspiel mit Ihrer Gesichtsform geplant.', image: IMG.eingang },
  { n: '03', title: 'Behandlung', text: 'Präzise Entnahme und Platzierung – ruhig, sorgfältig und Schritt für Schritt.', image: IMG.opRaum },
  { n: '04', title: 'Nachsorge', text: 'Pflegehinweise, Kontrolltermine und ein fester Ansprechpartner für Ihre Fragen.', image: IMG.flur },
  { n: '05', title: 'Entwicklung', text: 'Ergebnisse entwickeln sich über Monate. Der Verlauf ist individuell und wird begleitet.', image: IMG.warte },
];

export const CLINIC = {
  phone: '+49 2161 2963017',
  email: 'info@dionhairclinic.de',
  street: 'Schürenweg 61',
  city: '41063 Mönchengladbach',
};
